import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { ProductPublishEndedFilterSchema } from './-zod-schema';

// プロダクト > 公開終了タブ（読み取り専用）。
// publishStatus=UNPUBLISHED のプロダクトのみを一覧表示する。
// URL search のスキーマだけここで定義し、コンポーネントは index.lazy.tsx で
// 遅延ロードする。
export const Route = createFileRoute('/_stacktrace/products/_layout/published-ended/')({
  validateSearch: zodValidator(ProductPublishEndedFilterSchema)
});